import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RoleGuard from '../../components/guards/RoleGuard';
import { ROLES, DEPARTMENTS } from '../../auth/permissions';
import PayrollAdminPage from './PayrollAdminPage';
import MyPayrollPage from './MyPayrollPage';
import ComingSoon from '../ComingSoon';

export default function PayrollRoutes() {
  return (
    <Routes>
      <Route path="" element={<Navigate to="my" replace />} />

      <Route
        path="manage"
        element={
          <RoleGuard
            anyOf={[
              { roles: [ROLES.SUPERADMIN] },
              { roles: [ROLES.ADMIN], depts: [DEPARTMENTS.HR, DEPARTMENTS.PAYROLL] },
            ]}
          >
            <PayrollAdminPage />
          </RoleGuard>
        }
      />

      <Route path="my" element={<MyPayrollPage />} />
      <Route path="*" element={<ComingSoon title="Not Found" />} />
    </Routes>
  );
}
